import React from 'react';
import { Color } from 'shared/src/modules/styles/colors';

export default (props: any = { color: Color.black }) => ({
  svg: (
    <g id="Web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="HR-Health-Record-Summary---Overlay" transform="translate(-409.000000, -1008.000000)">
        <g id="Group-15" transform="translate(410.000000, 1009.536200)">
          <g id="Group-14" transform="translate(-0.000000, 0.000000)">
            <g id="Group-5" stroke={props.color} strokeLinejoin="round" strokeWidth="1.5">
              <polyline
                id="Stroke-1"
                strokeLinecap="square"
                points="0.641907692 4.11018462 4.19021538 4.11018462 4.19021538 0.5628"
              ></polyline>
              <polygon
                id="Stroke-3"
                points="8.03187692 5.47043077 4.48449231 9.01781538 4.48449231 23.3079692 17.4860308 23.3079692 17.4860308 5.47043077"
              ></polygon>
            </g>
            <polyline
              id="Stroke-6"
              stroke={props.color}
              strokeWidth="1.5"
              strokeLinecap="square"
              strokeLinejoin="round"
              points="5.35735385 10.3067077 8.90566154 10.3067077 8.90566154 6.75932308"
            ></polyline>
            <polygon
              id="Stroke-7"
              stroke={props.color}
              strokeWidth="1.5"
              strokeLinejoin="round"
              points="5.40784615 9.78701538 8.95523077 6.23963077 13.6933846 6.23963077 13.6933846 0.197169231 4.23923077 0.197169231 0.692769231 3.74455385 0.692769231 18.0347077 5.40784615 18.0347077"
            ></polygon>
            <polygon
              id="Fill-9"
              fill="#212121"
              points="7.13076923 13.8692308 15.4384615 13.8692308 15.4384615 12.9461538 7.13076923 12.9461538"
            ></polygon>
            <polygon
              id="Fill-10"
              fill="#212121"
              points="7.13076923 15.5898462 15.4384615 15.5898462 15.4384615 14.6667692 7.13076923 14.6667692"
            ></polygon>
            <polygon
              id="Fill-11"
              fill="#212121"
              points="7.13076923 19.2027692 15.4384615 19.2027692 15.4384615 18.2796923 7.13076923 18.2796923"
            ></polygon>
            <polygon
              id="Fill-12"
              fill="#212121"
              points="7.13076923 20.9243077 14.2227692 20.9243077 14.2227692 20.0012308 7.13076923 20.0012308"
            ></polygon>
            <polygon
              id="Fill-13"
              fill="#212121"
              points="7.13076923 17.3113846 12.6064615 17.3113846 12.6064615 16.3883077 7.13076923 16.3883077"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 20 26'
});
